if (!customElements.get("hys-pvc-swiper")) {
  customElements.define(
    "hys-pvc-swiper",
    class hysPvcSwiper extends HTMLElement {
      connectedCallback() {
        // console.log("hys-pvc-swiper connectedCallback triggered");

        this.swiperEl = this.querySelector(".swiper");
        // this.clientWidth = window.innerWidth;
        this.isMobile = window.matchMedia("(max-width: 768px)").matches;
        this.autoPlay = this.hasAttribute("data-autoplay");
        this.gap = (window.innerWidth * 32) / (this.isMobile ? 440 : 1280);
        this.onVideoPlay = () => this.stopAutoplay();
        this.onVideoStop = () => this.startAutoplayIfAllowed();

        this.addEventListener("hys:pvc:video-play", this.onVideoPlay);
        this.addEventListener("hys:pvc:video-stop", this.onVideoStop);
        // console.log("Video event listeners added");

        this.initSwiper();
      }

      disconnectedCallback() {
        // console.log("hys-pvc-swiper disconnectedCallback triggered");

        this.removeEventListener("hys:pvc:video-play", this.onVideoPlay);
        this.removeEventListener("hys:pvc:video-stop", this.onVideoStop);
        // console.log("Video event listeners removed");
      }

      stopAllVideos() {
        // console.log("Stopping all videos...");

        this.swiperEl.querySelectorAll("video").forEach((video) => {
          video.pause();
          video.currentTime = 0;
        });

        // 同步 Plyr UI 状态
        this.swiperEl.querySelectorAll(".plyr-laucher").forEach((el) => {
          el._plyr?.pause();
        });
      }

      stopAutoplay() {
        if (!this.autoPlay) return;
        // console.log("Stopping autoplay...");

        this.swiper?.autoplay?.stop?.();
      }

      startAutoplayIfAllowed() {
        if (!this.autoPlay) return;

        const hasPlayingVideo = Array.from(
          this.swiperEl.querySelectorAll("video")
        ).some((video) => !video.paused && !video.ended);

        if (hasPlayingVideo) return;

        // console.log("Starting autoplay...");

        this.swiper?.autoplay?.start?.();
      }

      initSwiper() {
        // console.log("Initializing swiper...");

        this.swiper = new Swiper(this.swiperEl, {
          slidesPerView: 1.2,
          spaceBetween: 32,
          speed: 1000,
          loop: true,
          touchStartPreventDefault: false,
          touchMoveStopPropagation: false,
          breakpoints: {
            1000: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          },
          autoplay: this.autoPlay ? {
            delay: 1000,
            pauseOnMouseEnter: true,
          }
            : false,
          on: {
            slideChangeTransitionEnd: () => {
              // console.log("Swiper slide change transition ended");
              this.stopAllVideos();
            },
          },
        });
      }
    }
  );
}

if (!customElements.get("hys-pvc-plyr-video")) {
  customElements.define(
    "hys-pvc-plyr-video",
    class hysPvcPlyrVideo extends HTMLElement {
      connectedCallback() {
        // console.log("hys-pvc-plyr-video connectedCallback triggered");

        if (this.player) return;

        this.el = this.querySelector(".plyr-laucher");
        this.player = new Plyr(this.el, {
          controls: `
          <div class="plyr__control plyr__control--overlaid">
              <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
                  <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="none" version="1.1" width="72" height="72" viewBox="0 0 72 72"><g><g><path d="M72,36Q72,36.883751,71.956635,37.766438Q71.913269,38.649124,71.826653,39.528622Q71.740028,40.408112,71.610352,41.282299Q71.480682,42.156479,71.308266,43.023251Q71.135849,43.890018,70.92112,44.747284Q70.70639,45.604553,70.449852,46.450249Q70.193314,47.295944,69.895584,48.128033Q69.597855,48.960121,69.259659,49.7766Q68.921455,50.593079,68.543602,51.391983Q68.165756,52.190884,67.749161,52.970284Q67.332565,53.74968,66.87822,54.507698Q66.423889,55.265717,65.932899,56.000526Q65.44191,56.735336,64.915459,57.445171Q64.389015,58.155006,63.828369,58.838158Q63.267723,59.521305,62.674232,60.176121Q62.080742,60.830933,61.455841,61.455841Q60.830933,62.080742,60.176121,62.674236Q59.521305,63.267723,58.838158,63.828373Q58.155006,64.389015,57.445171,64.915466Q56.735336,65.44191,56.000526,65.932899Q55.265717,66.423889,54.507698,66.87822Q53.74968,67.332565,52.97028,67.749161Q52.19088,68.165756,51.391979,68.543602Q50.593079,68.921455,49.776596,69.259659Q48.960117,69.597855,48.128029,69.895584Q47.295944,70.193314,46.450249,70.449852Q45.604553,70.70639,44.747284,70.921127Q43.890015,71.135857,43.023247,71.308273Q42.156479,71.480682,41.282295,71.610352Q40.408112,71.740028,39.528618,71.826653Q38.649124,71.913269,37.766438,71.956635Q36.883751,72,36,72Q35.116249,72,34.233566,71.956635Q33.350876,71.913269,32.471382,71.826653Q31.591887,71.740028,30.717703,71.610352Q29.843517,71.480682,28.976748,71.308266Q28.109978,71.135849,27.252712,70.92112Q26.395447,70.70639,25.549753,70.449852Q24.704056,70.193314,23.871965,69.895584Q23.039875,69.597855,22.223396,69.259659Q21.406918,68.921455,20.608015,68.543602Q19.809116,68.165756,19.029718,67.749161Q18.250319,67.332565,17.4923,66.87822Q16.734282,66.423889,15.99947,65.932899Q15.264658,65.44191,14.554824,64.915459Q13.844989,64.389015,13.16184,63.828369Q12.478693,63.267723,11.823877,62.674232Q11.169062,62.080742,10.544155,61.455841Q9.9192495,60.830933,9.3257589,60.176121Q8.7322693,59.521305,8.1716242,58.838158Q7.6109781,58.155006,7.0845284,57.445171Q6.5580788,56.735336,6.0670929,56.000526Q5.576108,55.265717,5.1217694,54.507698Q4.6674309,53.74968,4.250834,52.97028Q3.8342369,52.19088,3.4563847,51.391979Q3.0785329,50.593079,2.7403364,49.776596Q2.4021397,48.960117,2.1044133,48.128029Q1.8066869,47.295944,1.5501478,46.450249Q1.2936087,45.604553,1.0788748,44.747284Q0.86414099,43.890015,0.69172978,43.023247Q0.51931864,42.156479,0.38964558,41.282295Q0.25997251,40.408112,0.17334983,39.528618Q0.086727142,38.649124,0.043363571,37.766438Q0,36.883751,0,36Q0,35.116249,0.043363571,34.233566Q0.086727142,33.350876,0.17334983,32.471382Q0.25997251,31.591887,0.38964558,30.717703Q0.51931864,29.843517,0.69172978,28.976748Q0.86414099,28.109978,1.0788748,27.252712Q1.2936087,26.395447,1.5501478,25.549753Q1.8066869,24.704056,2.1044135,23.871965Q2.4021397,23.039875,2.7403364,22.223396Q3.0785329,21.406918,3.4563849,20.608015Q3.8342371,19.809116,4.2508345,19.029718Q4.6674314,18.250319,5.1217699,17.4923Q5.576108,16.734282,6.0670934,15.99947Q6.5580788,15.264658,7.084528,14.554824Q7.6109776,13.844989,8.1716232,13.16184Q8.7322683,12.478693,9.3257589,11.823877Q9.9192495,11.169062,10.544155,10.544155Q11.169062,9.9192495,11.823877,9.3257589Q12.478693,8.7322693,13.16184,8.1716242Q13.844989,7.6109781,14.554823,7.0845284Q15.264658,6.5580788,15.99947,6.0670929Q16.73428,5.576108,17.492298,5.1217694Q18.250317,4.6674309,19.029716,4.250834Q19.809113,3.8342369,20.608013,3.4563847Q21.406914,3.0785329,22.223394,2.7403364Q23.039873,2.4021397,23.871964,2.1044133Q24.704056,1.8066869,25.549753,1.5501478Q26.395447,1.2936087,27.252712,1.0788748Q28.109978,0.86414099,28.976748,0.69172978Q29.843517,0.51931864,30.717703,0.38964558Q31.591888,0.25997251,32.471386,0.17334983Q33.35088,0.086727142,34.233566,0.043363571Q35.116249,0,36,0Q36.883751,0,37.766438,0.043363571Q38.649124,0.086727142,39.528622,0.17334983Q40.408112,0.25997251,41.282299,0.38964558Q42.156479,0.51931864,43.023251,0.69172978Q43.890018,0.86414099,44.747284,1.0788748Q45.604553,1.2936087,46.450249,1.5501478Q47.295944,1.8066869,48.128033,2.1044135Q48.960121,2.4021397,49.7766,2.7403364Q50.593079,3.0785329,51.391983,3.4563849Q52.190884,3.8342371,52.970284,4.2508345Q53.74968,4.6674314,54.507698,5.1217699Q55.265717,5.576108,56.000526,6.0670934Q56.735336,6.5580788,57.445171,7.084528Q58.155006,7.6109776,58.838158,8.1716232Q59.521305,8.7322683,60.176121,9.3257589Q60.830933,9.9192495,61.455841,10.544155Q62.080742,11.169062,62.674236,11.823877Q63.267723,12.478693,63.828373,13.16184Q64.389015,13.844989,64.915466,14.554823Q65.44191,15.264658,65.932899,15.99947Q66.423889,16.73428,66.87822,17.492298Q67.332565,18.250317,67.749161,19.029716Q68.165756,19.809113,68.543602,20.608013Q68.921455,21.406914,69.259659,22.223394Q69.597855,23.039873,69.895584,23.871964Q70.193314,24.704056,70.449852,25.549753Q70.70639,26.395447,70.921127,27.252712Q71.135857,28.109978,71.308273,28.976748Q71.480682,29.843517,71.610352,30.717703Q71.740028,31.591888,71.826653,32.471386Q71.913269,33.35088,71.956635,34.233566Q72,35.116249,72,36ZM68,36Q68,35.214443,67.961456,34.429832Q67.922913,33.645226,67.845917,32.863453Q67.768921,32.081676,67.653656,31.304623Q67.538391,30.527569,67.385132,29.757109Q67.231873,28.986647,67.041,28.224634Q66.850128,27.46262,66.622093,26.710892Q66.394058,25.95916,66.12941,25.219524Q65.864761,24.479889,65.56414,23.754128Q65.263519,23.02837,64.927658,22.318235Q64.591782,21.608103,64.221481,20.915306Q63.851173,20.222507,63.447311,19.548712Q63.043457,18.874918,62.607025,18.221752Q62.170593,17.568586,61.702641,16.937622Q61.234688,16.306658,60.736336,15.699415Q60.237984,15.092173,59.710434,14.510114Q59.182884,13.928055,58.627415,13.372582Q58.071941,12.81711,57.489887,12.289564Q56.907829,11.762016,56.300587,11.263666Q55.69334,10.765314,55.062374,10.297359Q54.431408,9.8294029,53.778244,9.392972Q53.125076,8.9565401,52.451283,8.5526838Q51.777489,8.1488276,51.084694,7.7785192Q50.391891,7.4082108,49.681755,7.0723419Q48.971622,6.7364736,48.245865,6.4358544Q47.520103,6.1352353,46.780468,5.8705893Q46.040833,5.6059437,45.289104,5.3779092Q44.537373,5.1498747,43.77536,4.9589996Q43.013344,4.7681255,42.242882,4.614871Q41.47242,4.4616165,40.69537,4.3463516Q39.91832,4.2310867,39.136547,4.154089Q38.354774,4.0770907,37.570164,4.0385456Q36.785553,4,36,4Q35.214443,4,34.429832,4.0385456Q33.645226,4.0770907,32.863453,4.154089Q32.081676,4.2310867,31.304623,4.3463516Q30.527569,4.4616165,29.757109,4.614871Q28.986647,4.7681255,28.224634,4.9589996Q27.46262,5.1498742,26.710892,5.3779092Q25.95916,5.6059437,25.219524,5.8705888Q24.479889,6.1352348,23.754128,6.435854Q23.02837,6.7364731,22.318235,7.0723419Q21.608103,7.4082103,20.915306,7.7785187Q20.222507,8.1488266,19.548712,8.5526838Q18.874918,8.9565392,18.221752,9.392971Q17.568586,9.8294029,16.937622,10.297358Q16.306658,10.765313,15.699415,11.263665Q15.092173,11.762016,14.510114,12.289562Q13.928055,12.81711,13.372582,13.372581Q12.81711,13.928054,12.289564,14.510113Q11.762016,15.092172,11.263666,15.699415Q10.765314,16.306658,10.297359,16.937622Q9.8294029,17.568586,9.392972,18.221752Q8.9565401,18.874918,8.5526838,19.548712Q8.1488276,20.222507,7.7785192,20.915306Q7.4082108,21.608103,7.0723419,22.318235Q6.7364736,23.02837,6.4358544,23.754128Q6.1352348,24.479889,5.8705893,25.219524Q5.6059437,25.95916,5.3779092,26.71089Q5.1498742,27.46262,4.9589996,28.224632Q4.7681255,28.986647,4.614871,29.757109Q4.4616165,30.527569,4.3463516,31.304623Q4.2310867,32.081676,4.154089,32.863453Q4.0770907,33.645226,4.0385456,34.429832Q4,35.214443,4,36Q4,36.785553,4.0385456,37.570168Q4.0770907,38.354774,4.154089,39.136551Q4.2310867,39.91832,4.3463516,40.695374Q4.4616165,41.472424,4.6148705,42.242886Q4.7681246,43.013348,4.9589992,43.77536Q5.1498737,44.537376,5.3779087,45.289108Q5.6059432,46.040833,5.8705888,46.780468Q6.1352348,47.520103,6.435854,48.245865Q6.7364731,48.971626,7.0723419,49.681759Q7.4082103,50.391895,7.7785187,51.084694Q8.1488266,51.777493,8.5526838,52.451286Q8.9565392,53.125076,9.392971,53.778244Q9.8294029,54.431412,10.297358,55.062378Q10.765313,55.693344,11.263665,56.300591Q11.762016,56.907829,12.289562,57.489891Q12.81711,58.071945,13.372581,58.627419Q13.928054,59.182892,14.510113,59.710438Q15.092172,60.237984,15.699415,60.73634Q16.306658,61.234688,16.937622,61.702644Q17.568586,62.170597,18.221752,62.607029Q18.874918,63.043461,19.548712,63.447315Q20.222507,63.851173,20.915306,64.221481Q21.608103,64.591782,22.318235,64.927658Q23.02837,65.263519,23.754128,65.56414Q24.479889,65.864761,25.219524,66.12941Q25.95916,66.394058,26.71089,66.622093Q27.46262,66.850128,28.224632,67.041Q28.986647,67.231873,29.757109,67.385132Q30.527569,67.538391,31.304623,67.653656Q32.081676,67.768921,32.863453,67.845917Q33.645226,67.922913,34.429832,67.961456Q35.214443,68,36,68Q36.785553,68,37.570168,67.961456Q38.354774,67.922913,39.136551,67.845917Q39.91832,67.768921,40.695374,67.653656Q41.472424,67.538391,42.242886,67.385132Q43.013348,67.231873,43.77536,67.041Q44.537376,66.850128,45.289108,66.622093Q46.040833,66.394058,46.780468,66.12941Q47.520103,65.864761,48.245865,65.56414Q48.971626,65.263519,49.681759,64.927658Q50.391895,64.591782,51.084694,64.221481Q51.777493,63.851173,52.451286,63.447311Q53.125076,63.043457,53.778244,62.607025Q54.431412,62.170593,55.062378,61.702641Q55.693344,61.234688,56.300591,60.736336Q56.907829,60.237984,57.489891,59.710434Q58.071945,59.182884,58.627419,58.627415Q59.182892,58.071941,59.710438,57.489887Q60.237984,56.907829,60.73634,56.300587Q61.234688,55.69334,61.702644,55.062374Q62.170597,54.431408,62.607029,53.778244Q63.043461,53.125076,63.447315,52.451283Q63.851173,51.777489,64.221481,51.084694Q64.591782,50.391891,64.927658,49.681755Q65.263519,48.971622,65.56414,48.245865Q65.864761,47.520103,66.12941,46.780468Q66.394058,46.040833,66.622093,45.289104Q66.850128,44.537373,67.041,43.77536Q67.231873,43.013344,67.385132,42.242882Q67.538391,41.47242,67.653656,40.69537Q67.768921,39.91832,67.845917,39.136547Q67.922913,38.354774,67.961456,37.570164Q68,36.785553,68,36Z" fill="#FFFFFF" fill-opacity="1"/></g><g transform="matrix(0,1,-1,0,68,-28)"><path d="M64,20L77.856405,38L50.1435938,38L64,20Z" fill="#FFFFFF" fill-opacity="1"/></g></g></svg>
              </button>
          </div>
          `,
        });
        this.el._plyr = this.player;

        const notify = (type) => {
          // console.log(`Dispatching event: ${type}`);
          this.dispatchEvent(
            new CustomEvent(type, { bubbles: true, composed: true })
          );
        };

        // 初始化播放器事件
        this.player.on("play", () => {
          // console.log("Video is playing");
          notify("hys:pvc:video-play");
        });
        this.player.on("pause", () => {
          // console.log("Video is paused");
          notify("hys:pvc:video-stop");
        });
        this.player.on("ended", () => {
          // console.log("Video has ended");
          notify("hys:pvc:video-stop");
        });

        // 获取最接近的 .plyr 元素
        this.plyrRoot = this.el.closest(".plyr");
        if (!this.plyrRoot) return;
        // console.log("Found plyrRoot:", this.plyrRoot);

        this.isToggleInProgress = false;
        this.lastToggleAt = 0;
        this.onPlyrRootClick =
          this.onPlyrRootClick ||
          ((e) => {
            if (!this.player) return;
            if (this.isToggleInProgress) return;

            const now = Date.now();
            if (now - this.lastToggleAt < 350) return;

            const target = e.target;
            if (target && typeof target.closest === "function") {
              if (
                target.closest("[data-plyr]") ||
                target.closest(".plyr__controls") ||
                target.closest("a,button,input,textarea,select,label")
              ) {
                return;
              }
            }

            e.preventDefault();
            e.stopPropagation();

            this.lastToggleAt = now;
            this.isToggleInProgress = true;

            this.togglePlay(() => {
              setTimeout(() => {
                this.isToggleInProgress = false;
              }, 250);
            });
          });

        this.plyrRoot.removeEventListener("click", this.onPlyrRootClick);
        this.plyrRoot.addEventListener("click", this.onPlyrRootClick);
      }

      disconnectedCallback() {
        if (this.plyrRoot && this.onPlyrRootClick) {
          this.plyrRoot.removeEventListener("click", this.onPlyrRootClick);
        }

        this.player?.destroy?.();
        this.player = null;
        this.el = null;
        this.plyrRoot = null;
      }

      togglePlay(callback) {
        if (!this.player) return;

        // 根据播放器当前的播放状态判断
        if (this.player.playing) {
          // console.log("Pausing video...");
          this.player.pause();
        } else {
          // console.log("Playing video...");
          this.player.play();
        }

        // 执行回调，标志操作完成
        if (callback) callback();
      }
    }
  );
}
